module.exports = {"nodeURL":"http://localhost:8545"}


//////////////////
// WEBPACK FOOTER
// ./src/settings.json
// module id = 1035
// module chunks = 0